// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2h0-N","clinicsSelect":"styles_clinicsSelect__2-cKH"};